import React, { useState, useEffect } from "react";
import useStyles from "./styles";
import api from "../../../Axios/api";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import MaterialTable from "material-table";
import Rating from "@material-ui/lab/Rating";
import LibraryAddIcon from "@material-ui/icons/LibraryAdd";
import { Link } from "react-router-dom";
// MUI Components
import { Grid, Typography, Avatar, Paper, Button } from "@material-ui/core";
import pal from "../../../themes/palette";
import { useUserContext } from "../../../context/UserContext";
import { RemoveCircle } from "@material-ui/icons";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

export default function Reviews() {
  const { store } = useUserContext();
  const token = store.data.token;
  const classes = useStyles();
  const [details, setDetails] = useState([]);
  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };


  const columns = [
    {
      title: "Id#",
      field: "tableData.id",
      render: ({ tableData }) => <div>{tableData.id + 1}</div>,
      hidden: false,
      export: false,
    },
    // {
    //   title: "Image",
    //   field: "profilePic",
    //   render: ({ profilePic }) => (
    //     <img
    //       src={profilePic != null ? profilePic : ImgNotAvailable}
    //       alt="Profile Pic"
    //       style={{ width: 40, height: 40, borderRadius: "50%" }}
    //     />
    //   ),
    // },
    {
      title: "Product",
      field: "productName",
      width: 150,
    },
    {
      title: "Comment",
      field: "comment",
      width: 150,
    },

    {
      title: "Store",
      field: "storeName",
      width: 150,
    },
    {
      title: "Rating",
      field: "rating",
      render: ({ rating }) => (
        <Rating
          name="half-rating-read"
          defaultValue={rating ? rating : 0}
          //className={classes.ratingStars}
          style={{ fontSize: 14 }}
          precision={0.5}
          readOnly
        />
      ),
      width: 150,
    },
    {
      title: "Date",
      field: "createdAt",
      render: ({ createdAt }) => (
        <div>
          {createdAt.split("T")[0]} , {createdAt.split("T")[1].split(":")[0]}:
          {createdAt.split("T")[1].split(":")[1]}{" "}
        </div>
      ),
    },
    {
      title: "Actions",
      render: ({_id }) => (
        <Button color="primary" variant="contained" onClick={()=> deleteReview(_id)}>
          {" "}
          <RemoveCircle style={{ marginRight: 4 }} />
          Delete
        </Button>
      ),
    },
  ];

  const retrivingAllReviews = async () => {
    await api
      .get("/buyer/reviews/view", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        // console.log(res.data.data);
        setDetails(res.data.data.reviews);
      })
      .catch((error) =>
        console.log("ERROR: " + JSON.stringify(error.response.data.error))
      );
  };

  const deleteReview = async (id) => {
    await api
      .delete(`/buyer/product/review/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        // console.log(res.data.data);
        let temp = details
        temp = temp.filter((review) => {return review._id != id})
        setDetails(temp);
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "Review Deleted successfully. ",
          open: true,
        });
      })
      .catch((error) =>
        console.log("ERROR: " + JSON.stringify(error.response.data.error))
      );
  };

  useEffect(() => {
    //scroll to the top of page
    window.scrollTo(0, 0);
    // Retriving List of Products from API
    retrivingAllReviews();
  }, []);

  return (
    <div>
       <Snackbar
        open={open}
        anchorOrigin={{ vertical, horizontal }}
        autoHideDuration={3000}
        onClose={handleCloseSnackBar}
        key={vertical + horizontal}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleCloseSnackBar}
          severity={snackBarstate.type}
        >
          {snackBarstate.message}
        </MuiAlert>
      </Snackbar>
      <div className={classes.mainAboutusContainer}>
        <Breadcrumbs
          style={{ paddingTop: 30, paddingBottom: 15 }}
          aria-label="breadcrumb"
        >
          <Link className={classes.bCrumbLink} style={{ color: "grey" }} to="/">
            Home
          </Link>
          <Link
            className={classes.bCrumbLink}
            style={{ color: "grey" }}
            to="/account"
          >
            My Account
          </Link>
          <Typography color="textPrimary">My Reviews</Typography>
        </Breadcrumbs>

        <div>
          <Grid container spacing={1} style={{ margin: "0px 0px 30px 0px" }}>
            <Grid item xs={12} sm={12} md={12} component={Paper}>
              <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                  <LibraryAddIcon />
                </Avatar>
                <Typography variant="h5" style={{ marginBottom: 20 }}>
                  My Reviews
                </Typography>
                <MaterialTable
                  style={{ width: "100%" }}
                  title="All Reviews"
                  data={details}
                  columns={columns}
                  // actions={[
                  //   (rowData) => ({
                  //     icon: () => <EditIcon />,
                  //     tooltip: "Edit",
                  //     onClick: (event, rowData) => {
                  //       setBuyerDetails(rowData);
                  //       handleOpen();
                  //     },
                  //   }),
                  // ]}
                  options={{
                    actionsColumnIndex: -1,
                    headerStyle: {
                      backgroundColor: pal.palette.primary.main,
                      color: "#fff",
                      whiteSpace: "nowrap",
                    },

                    // tableLayout: "auto",
                    pagination: "false",
                  }}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} component={Paper}></Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
}
